<template>
  <div>
        <ImportDetails/>
    </div>
</template>

<script>
import ImportDetails from "@/components/components-base/importdg2/detail/ImportDetails.vue";
export default {
    components: {
        ImportDetails
    }
}
</script>
